module.exports = __webpack_public_path__ + "static/media/rogue-lose.a1532131.png";